import { render } from "./SellersList.vue?vue&type=template&id=3a1f7ad8"
import script from "./SellersList.vue?vue&type=script&lang=js"
export * from "./SellersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__